import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function SignOut(props) {
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="SignOutIcon">
                <path d="M8.14,26.09H32.36a2.09,2.09,0,1,0,0-4.18H8.14l2.7-2.7a2.09,2.09,0,1,0-2.95-3L1.61,22.52l-.13.15,0,0a.64.64,0,0,0-.1.13l0,0L1.25,23l0,0-.07.16v0l-.06.17v0a1.21,1.21,0,0,0-.05.18.09.09,0,0,1,0,.05c0,.05,0,.1,0,.15a2.21,2.21,0,0,0,0,.42c0,.05,0,.1,0,.15a.09.09,0,0,1,0,.05,1.21,1.21,0,0,0,.05.18v0l.06.17v0c0,.06.05.11.07.16l0,0,.08.14,0,0a.64.64,0,0,0,.1.13l0,0,.13.15,6.28,6.27a2.05,2.05,0,0,0,1.47.61,2.09,2.09,0,0,0,1.48-3.57Zm0,0"/>
                <path d="M29.9,6.9a17.1,17.1,0,0,0-14.21,7.57,2.09,2.09,0,0,0,3.47,2.33,12.92,12.92,0,1,1,0,14.42,2.09,2.09,0,0,0-3.47,2.34A17.1,17.1,0,1,0,29.9,6.9Zm0,0"/>
            </g>
        </SvgIcon>
    );
}

export default SignOut;